import { IMailTemplate } from "../typings/IMailTemplate"
import http from "./client"

interface IEmailDraftListRequestPrams {
  course_id: string | number;
  general: boolean;
  search?: string;
  order: 'asc' | 'desc',
  sortBy: 'name' | 'created' | 'last_used'
}

async function list(params: IEmailDraftListRequestPrams) {
  const response = await http.get('/api/mail-template/list', {
    params: {
      ...params,
      general: params.general ? 'yes' : 'no'
    },
  }); // Array<Partial<IMailTemplate>> {id, course_id, type,general,name,subject,created,last_used}
  return response.data;
}

async function getById(templateId: number | string) {
  const response = await http.get('/api/mail-template/by-id', {
    params:{
      id: templateId
    }
  });

  return  response.data;
}

async function create(emailTemplate: Partial<IMailTemplate>, courseId: string | number) {
  const response = await http.post('/api/mail-template/save', emailTemplate, {
    params: {
      course_id: courseId
    }
  } );
  return response.data;
}

async function update(emailTemplate: Partial<IMailTemplate>, courseId: string | number) {
  const response = await http.post('/api/mail-template/save', emailTemplate, {
    params: {
      course_id: courseId
    }
  } );
  return response.data;
}

async function remove(templateId: number, courseId: string | number) {
  const response = await http.post('/api/mail-template/delete',null ,{
    params: {
      id: templateId,
      course_id: courseId
    }
  } );
  return response.data;
}
export const emails = {
  list, create, update, getById, remove
}